<template>
  <v-container fluid>
    <v-data-table
      :headers="dessertHeaders"
      :items="agents"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :search="search"
      item-key="id_tour"
      show-expand
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Data Itinerari</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            solo
            dense
            append-icon="mdi-magnify"
            label="Search Data Tour"
            class="mr-3 white"
            outlined
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-row>
            <v-col>
              <v-simple-table>
                <thead>
                  <tr class="font-weight-bold text-h6  ">
                    <td>
                      <span class=" text-h6 "> Total Perpax Adult </span>
                    </td>
                    <td>
                      <span class=" text-h6 ">: Rp. {{ Number(item.total_perpax_adult).toLocaleString() }}</span>
                    </td>
                  </tr>
                  <tr
                    v-if="item.total_cnb > 0"
                    class="font-weight-bold text-h6  "
                  >
                    <td>
                      <span class="  text-h6 ">Total Perpax CNB </span>
                    </td>
                    <td>
                      <span class=" text-h6 ">: Rp. {{ Number(item.total_perpax_cnb).toLocaleString() }}</span>
                    </td>
                  </tr>
                  <tr
                    v-if="item.total_cwb > 0"
                    class="font-weight-bold text-h6  "
                  >
                    <td>
                      <span class=" text-h6 ">Total Perpax CWB </span>
                    </td>
                    <td>
                      <span class=" text-h6 ">: Rp. {{ Number(item.total_perpax_cwb).toLocaleString() }}</span>
                    </td>
                  </tr>
                </thead>
              </v-simple-table>
            </v-col>
          </v-row>
        </td>
      </template>
      <template #[`item.status_tour`]="{ item }">
        <v-btn
          :color="getColor(item.status_tour)"
          rounded
          small
          dark
          @click="SetStatus(item.id_tour)"
        >
          {{ item.status_tour }}
        </v-btn>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          small
          class="mr-2 text-capitalize primary"
          @click="editItem(item)"
        >
          <v-icon>{{ icons.mdiPencil }}</v-icon>
        </v-btn>
        <v-btn
          small
          class="mr-2 text-capitalize primary"
          @click="LihatTour(item)"
        >
          <v-icon>{{ icons.mdiEyeCircle }}</v-icon>
        </v-btn>
        <v-btn
          small
          class="mr-2 text-capitalize primary"
          @click="Cetak(item)"
        >
          <v-icon>{{ icons.mdiPrinter }}</v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog3"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
      @click:outside="CekDialog()"
    >
      <v-card>
        <v-card-title class="text-h5  bg-gradient-primary">
          <v-btn
            icon
            dark
            @click="CekDialog()"
          >
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>

          <span>Tour {{ data.guest_name }}</span>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-row>
            <v-col>
              <DataService :item="data" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogstatus"
      scrollable
      max-width="300px"
      @click:outside="status = 'Waiting'"
    >
      <v-card>
        <v-card-title>Select Status Tour</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-select
            v-model="status"
            dense
            outlined
            :items="['Waiting','Confirmed','Cancel']"
          />

          <v-menu
            v-if="status == 'Confirmed'"
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="cut_off_date"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="cut_off_date"
                label="Cut Off Date"
                readonly
                outlined
                dense
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="cut_off_date"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu.save(cut_off_date)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            class="ml-auto"
            color="primary"
            @click="ChangeStatusTour()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from 'axios'
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
  mdiCalendar,
  mdiEyeCircle,
  mdiPrinter,
} from '@mdi/js'
import DataService from './DataService.vue'

export default {
  components: { DataService },
  data() {
    return {
      menu: false,
      dialog3: false,
      dialogstatus: false,
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
        mdiCalendar,
        mdiEyeCircle,
        mdiPrinter,
      },
      modal: false,
      modal5: false,
      expanded: [],
      singleExpand: true,
      dialog: false,
      editedIndex: -1,
      search: '',
      data: [],
      form: {
        agent_name: '',
        agent_code: '',
        id_agent: '',
        phone: '',
        email: '',
        city: '',
        note: '',
      },
      service: [],
      dessertHeaders: [
        { text: 'Tour Code', value: 'tour_code' },
        { text: 'Guest Name', value: 'guest_name' },
        { text: 'Travel Date', value: 'travel_date' },
        { text: 'Adult', value: 'total_adult', width: 50 },
        { text: 'CNB', value: 'total_cnb', width: 50 },
        { text: 'CWB', value: 'total_cwb', width: 50 },
        { text: 'Status', value: 'status_tour', width: 50 },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          width: 250,
        },
      ],
      agents: [],
      regions: [],
      idtour: '',
      status: 'Waiting',
      cut_off_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add New Agent' : 'Edit Agent'
    },
    TittleButton() {
      return this.editedIndex === -1 ? 'Save Agent' : 'Update Agent'
    },
  },
  mounted() {
    this.initialize()
    this.initializeregion()
  },
  methods: {
    getColor(status) {
      if (status < 'Cancel') {
        return 'error'
      } if (status < 'Waiting') {
        return 'success'
      }

      return 'primary'
    },
    SetStatus(idtour) {
      this.idtour = idtour
      this.dialogstatus = true
    },
    Cetak(item) {
      window.open(`${process.env.VUE_APP_apiURL}/api/CetakProposal/?id=${item.id_tour}`, '_blank')
    },
    ChangeStatusTour() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/ChangeStatusTour', { id_tour: this.idtour, status: this.status, cut_off_date: this.cut_off_date }).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
        this.dialogstatus = false
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    LihatTour(data) {
      this.dialog3 = true
      this.data = data
    },
    initializeregion() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.get('auth/Region').then(response => {
        this.regions = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    CekDialog() {
      this.form = {
        agent_name: '',
        agent_code: '',
        id_agent: '',
        phone: '',
        email: '',
        city: '',
        note: '',
      }
      this.dialog3 = false
    },
    editItem(item) {
      this.$router.push({ path: 'NewTour', query: { id_tour: item.id_tour } })
    },
    deleteItem(item) {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/DeleteAgent', item).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    initialize() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/DataTour', { status_tour: 'Waiting' }).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.agents = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    Save() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveAgent', this.form).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
        this.dialog = false
        this.CekDialog()
        this.editedIndex = -1
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
